// MUI Styles:
import { createTheme, Theme } from "@mui/material/styles";
// Fonts:
import Poppins from "../../assets/fonts/poppins/Poppins.ttf";
import IranSans from "../../assets/fonts/IranSans/IRANSans.ttf";

declare module "@mui/private-theming" {
  interface DefaultTheme extends Theme {}
}

declare module "@mui/material/styles" {
  interface Palette {
    tertiary?: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };
    blue?: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };
  }
  interface PaletteOptions {
    tertiary?: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };
    blue?: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    tertiary?: true;
    blue?: true;
  }
}

export const theme = createTheme({
  direction: "ltr",
  typography: {
    fontFamily: [
      "Poppins",
      "IRANSans",
      "Arial",
      "Helvetica",
      "sans-serif",
    ].join(","),
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: "IRANSans";
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local("IRANSans"), local("IRANSans"), url(${IranSans}) format("truetype");
          unicoderange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
            U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
            U+FEFF;
        }

        @font-face {
          font-family: "Poppins";
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local("Poppins"), local("Poppins"), url(${Poppins}) format("truetype");
          unicoderange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
            U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
            U+FEFF;
        }

        a {
          text-decoration: none;
          color: inherit
        }
      `,
    },
  },
  palette: {
    primary: {
      main: "#1C212E",
      light: "#292E3B",
      dark: "#121212",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#8B6EDE",
      light: "#997EE4",
      dark: "#785fc1",
      contrastText: "#FFFFFF",
    },
    tertiary: {
      main: "#FFFFFF",
      light: "#eceff1",
      dark: "#f1f1f1",
      contrastText: "#313133",
    },
    blue: {
      main: "#3DC7FC",
      light: "#67d0f9",
      dark: "#27b3e9",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#EB4D4B",
      light: "#ef5350",
      dark: "#c62828",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#0FD672",
      light: "#32f191",
      dark: "#0bb961",
      contrastText: "#FFFFFF",
    },
    background: {
      paper: "#FFFFFF",
      default: "#ECECEC",
    },
    action: {
      disabled: "transparent",
    },
    text: {
      disabled: "none",
      primary: "#FFFFFF",
      secondary: "#292E3B",
    },
    divider: "#707070",
  },
});
